import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile ? "10vw": "36vw"}
      height={!isMobile ? "10vw": "36vw"}
      fill="none"
      viewBox="0 0 186 168"
    >
      <path
        stroke="#575757"
        strokeWidth="2"
        d="M24.364 8.4v1H185v23.2h-8.455v25.2h-8.454V83h-8.455v8.4H58.182v18.8h101.454V125H51.727v-8.4h-8.454V83h-8.455V41h-8.454V15.8H1V1h23.364v7.4zm42.271 134.4v1h8.455v14.8h-8.455v8.4H51.726v-8.4h-8.454v-14.8h8.454v-8.4h14.91v7.4zm93.001 0v1h8.455v14.8h-8.455v8.4h-14.909v-8.4h-8.454v-14.8h8.454v-8.4h14.909v7.4z"
      ></path>
    </svg>
  );
}

export default Icon;
